import React, {Component} from "react";
import {IconButton, Stack, Tooltip} from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import {addScreenshotToReport} from "../utils/screenshot_utils";
import {connect} from "react-redux";
import {componentIds, FileType, MetsRiskFactor} from "../../../utils/const";
import {isNull} from "../../../utils/utils";
import {Loading} from "../components/components";
import {store} from "../../../helper/store";
import {fetchCase} from "../../../redux_actions/case.action";

class AddToLnMets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currCase: {},
        }
    }

    addScreenshotToMets = (riskFactor) => {
        let {x, y, z, r} = this.props;
        addScreenshotToReport(componentIds.slideMaps, this.props.slide,
            this.props.activeMapId, this.props.extension, this.props.displaySetting,
            JSON.stringify({
                mapState: {x, y, z, r},
                metsRisk: riskFactor
            }), FileType.LNMET)
    }

    render() {
        if (!this.props.slide)
            return <Loading/>;

        let componentDisabled = isNull(this.props.slide.case);

        return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
            <Tooltip title={componentDisabled ? "Slide has no Case Assigned" : "Add Mets Medium"} placement={"bottom"}>
                <IconButton size="small" disabled={componentDisabled}
                            onClick={() => this.addScreenshotToMets(MetsRiskFactor.MEDIUM)}>
                    <AddPhotoAlternateIcon sx={{
                        color: 'yellow',
                        opacity: componentDisabled ? 0.6 : 1
                    }}/>
                </IconButton>
            </Tooltip>
        </Stack>
    }
}


const mapStateToProps = (state) => {
    let {activeMapId, displayedMapId} = state.gammaStateReducer;
    // let {slide, x, y, z, r, displaySetting} = state.mapsStateReducer[activeMapId];
    if (isNull(displayedMapId)) displayedMapId = activeMapId;
    let {slide, x, y, z, r, displaySetting} = state.mapsStateReducer[displayedMapId];
    let {extension} = state.screenshotStateReducer;
    let caseState = state.caseReducer;
    return {activeMapId, x, y, z, r, slide, extension, displaySetting, caseState};
}
export default connect(mapStateToProps)(AddToLnMets)
